import { render } from "./Section.vue?vue&type=template&id=4becc603&scoped=true"
const script = {}

import "./Section.vue?vue&type=style&index=0&id=4becc603&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4becc603"]])

export default __exports__